import { createAsyncThunk } from '@reduxjs/toolkit';
import { SecureClient, debug, APP_ID, APP_VERSION } from '../../../../utils';

export const PrePopulatePanApi = createAsyncThunk(
  'PrePopulatePanApi',
  async (prePopulatePanPayload, { dispatch }) => {
    dispatch({ type: 'PrePopulatePanApi/pending', payload: {} });

    const { customerId, Authorization, customerRefNum, custJourneyAns } =
      prePopulatePanPayload;
    debug('LOOK', `custJourneyAns in payload`, custJourneyAns);
    SecureClient({
      isEncrypted: true,
      customerId,
      otherPayloadDetailsPresent: true,
      route: 'customerJourney/prepopulatepan',
      payload: {
        appId: APP_ID,
        appVersion: APP_VERSION,
        customerRefNum,
        currentBlock: 'PREPAN',
        custJourneyAns,
      },
      headers: { Authorization },
      method: 'POST',
      successFn: (res) => {
        debug('WATCH', `Response: `, res);
        const prePopulatePanRes = res;
        dispatch({
          type: 'PrePopulatePanApi/fulfilled',
          payload: prePopulatePanRes,
        });
      },
      errorFn: (err) => {
        debug('ERROR', `Error: `, err);
        dispatch({ type: 'PrePopulatePanApi/rejected', payload: err });
      },
    });
  }
);

export const PrePopulatePanApi_extrareducer = {
  [PrePopulatePanApi.pending]: (state, action) => {
    state.prePopulatePanApiState.isLoading = true;
  },
  [PrePopulatePanApi.fulfilled]: (state, action) => {
    state.prePopulatePanApiState.isLoading = false;
    state.prePopulatePanApiState.isSuccess = true;
    state.prePopulatePanApiState.isError = false;
    state.prePopulatePanApiState.response = action.payload;
  },
  [PrePopulatePanApi.rejected]: (state, action) => {
    state.prePopulatePanApiState.isLoading = false;
    state.prePopulatePanApiState.isSuccess = false;
    state.prePopulatePanApiState.isError = true;
    state.prePopulatePanApiState.response = action.payload;
  },
};
